import React, { useEffect, useState } from 'react';
import {
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import accdetails from 'assets/icons/accdetails.svg';
import personalDetailsIcon from 'assets/icons/personalDetails.svg';
import help from 'assets/icons/help.svg';
import file from 'assets/icons/file.svg';
import logoutIcon from 'assets/icons/logout.svg';
import externalLinks from 'constants/externalLinks';
import { logout } from 'helpers/authHelper';
import auth from 'reactiveVars/auth.js';
import { useReactiveVar } from '@apollo/client';
import { getElementId } from 'helpers/functions';
import { elementType } from 'constants/elements';
import colors from 'assets/defs/colors';

const BurgerMenu = () => {
  const location = useLocation();
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const { hasSubscription } = useReactiveVar(auth);

  useEffect(() => {
    setIsDrawerOpen(false);
  }, [location]);

  if (!hasSubscription) {
    return;
  }

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const closeDrawerAndNavigate = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = () => {
    setIsDrawerOpen(false);
    logout();
  };
  return (
    <>
      <MenuIcon onClick={toggleDrawer} sx={{ color: colors.nlDarkPurple }} />
      <Drawer anchor="right" open={isDrawerOpen} onClose={toggleDrawer}>
        <CloseIcon
          onClick={toggleDrawer}
          sx={{ color: colors.nlDarkPurple }}
          style={{
            marginLeft: 'auto',
            marginTop: '40px',
            marginRight: '18px',
          }}
        />

        <Divider style={{ marginTop: '10px' }} />
        <List>
          <ListItemButton
            component={Link}
            to="/account-details"
            onClick={() => closeDrawerAndNavigate()}
            style={{ padding: '15px' }}
            id={getElementId('accountDetails', elementType.menu, false)}
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              <img src={accdetails} alt="details" />
            </ListItemIcon>
            <ListItemText primary="Account details" />
          </ListItemButton>
          <ListItemButton
            id={getElementId('personalDetails', elementType.menu, false)}
            component={Link}
            to="/personal-details"
            onClick={() => closeDrawerAndNavigate()}
            style={{ padding: '15px' }}
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              <img src={personalDetailsIcon} alt="Personal Details" />
            </ListItemIcon>
            <ListItemText primary="Personal details" />
          </ListItemButton>
          <ListItemButton
            id={getElementId('help', elementType.menu, false)}
            component={Link}
            to={externalLinks.getHelp}
            onClick={() => closeDrawerAndNavigate()}
            style={{ padding: '15px' }}
            rel="noopener noreferrer"
            target="_blank"
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              <img src={help} alt="help" />
            </ListItemIcon>
            <ListItemText primary="Get help" />
          </ListItemButton>
          <ListItemButton
            component={Link}
            id={getElementId('terms', elementType.menu, false)}
            to={externalLinks.terms}
            onClick={() => closeDrawerAndNavigate()}
            style={{ padding: '15px' }}
            rel="noopener noreferrer"
            target="_blank"
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              <img src={file} alt="file" />
            </ListItemIcon>
            <ListItemText primary="Terms and conditions" />
          </ListItemButton>
          <ListItemButton
            id={getElementId('privacy', elementType.menu, false)}
            component={Link}
            to={externalLinks.privacy}
            onClick={() => closeDrawerAndNavigate()}
            style={{ padding: '15px' }}
            rel="noopener noreferrer"
            target="_blank"
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              <img src={file} alt="file" />
            </ListItemIcon>
            <ListItemText primary="Privacy policy" />
          </ListItemButton>
        </List>
        <List style={{ marginTop: 'auto' }}>
          <ListItemButton
            id={getElementId('logout', elementType.menu, false)}
            style={{ padding: '15px' }}
            onClick={handleLogout}
          >
            <ListItemIcon style={{ minWidth: '30px' }}>
              <img src={logoutIcon} alt="logout" />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItemButton>
        </List>
      </Drawer>
    </>
  );
};
export default BurgerMenu;
